import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=d22ad912&scoped=true"
import script from "./CandidateList.vue?vue&type=script&lang=js"
export * from "./CandidateList.vue?vue&type=script&lang=js"
import style0 from "./CandidateList.vue?vue&type=style&index=0&id=d22ad912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22ad912",
  null
  
)

export default component.exports